/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of supplement action/justification
 * @export
 */
export const SupplementActionType = {
    Request: 'request',
    Approve: 'approve',
    Reject: 'reject',
    Info: 'info'
} as const;
export type SupplementActionType = typeof SupplementActionType[keyof typeof SupplementActionType];


export function instanceOfSupplementActionType(value: any): boolean {
    for (const key in SupplementActionType) {
        if (Object.prototype.hasOwnProperty.call(SupplementActionType, key)) {
            if (SupplementActionType[key as keyof typeof SupplementActionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SupplementActionTypeFromJSON(json: any): SupplementActionType {
    return SupplementActionTypeFromJSONTyped(json, false);
}

export function SupplementActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementActionType {
    return json as SupplementActionType;
}

export function SupplementActionTypeToJSON(value?: SupplementActionType | null): any {
    return value as any;
}

export function SupplementActionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SupplementActionType {
    return value as SupplementActionType;
}

